import type { EnhancedPackagesConfig } from '@/types/enhancedPackages.type';

export const IS_ENHANCED_PACKAGES_ENABLED = import.meta.env.VITE_ENHANCED_PACKAGES_ENABLED === 'true';

const ENHANCED_PACKAGES_CONFIG: EnhancedPackagesConfig = {
  isMessageDeliveryReportVisible: true,
  isTextStatusVisible: true,
  isMessageSmsAllowed: true,
  isFormsResultsVisible: true,
  isFormsDirectExportVisible: false,
  isFormsTemplatesVisible: true,
  isFormsSaveAsTemplateVisible: true,
  regularGroupsLimit: null,
  parishAdminsLimit: null,
};

const REGULAR_PACKAGES_CONFIG: EnhancedPackagesConfig = {
  isMessageDeliveryReportVisible: false,
  isTextStatusVisible: false,
  isMessageSmsAllowed: false,
  isFormsResultsVisible: false,
  isFormsDirectExportVisible: true,
  isFormsTemplatesVisible: false,
  isFormsSaveAsTemplateVisible: false,
  regularGroupsLimit: 10,
  parishAdminsLimit: 3,
};

export const getEnhancedPackagesConfig = ({ isEnhanced }: { isEnhanced?: boolean }): EnhancedPackagesConfig => {
  if (!IS_ENHANCED_PACKAGES_ENABLED) {
    return ENHANCED_PACKAGES_CONFIG;
  }

  if (isEnhanced === true) {
    return ENHANCED_PACKAGES_CONFIG;
  }

  return REGULAR_PACKAGES_CONFIG;
};
